import { useParams } from 'react-router-dom';
import EventDashboardFrame from './EventDashboardFrame';
import EventDetailsForm from './EventDetailsForm';
import useEventDetails from './hooks/useEventDetails';
import SmallLoader from '@/src/Common/components/SmallLoader';
import { Divider } from '@/src/tailwindui/divider';

export default function EventDashboardDetails() {
    const { activationId } = useParams();
    const {
        eventName,
        eventDate,
        eventLocation,
        isLoading,
        isSaving,
        lastSaved,
        setEventName,
        setEventDate,
        setEventLocation,
        lastChangesMade,
    } = useEventDetails(activationId || '');

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <SmallLoader />
            </div>
        );
    }

    return (
        <EventDashboardFrame
            navLocation="details"
            activationId={activationId || ''}
        >
            <div className="flex flex-row gap-4 items-end h-[50px] justify-end mt-2">
                <div className="flex flex-col items-end justify-end ">
                    {isSaving && <SmallLoader />}
                    {lastChangesMade &&
                        lastSaved &&
                        lastChangesMade < lastSaved && (
                            <p className="text-sm text-gray-500 italic">
                                All Changes Saved
                            </p>
                        )}
                </div>
            </div>
            <Divider className="my-10" soft />
            <EventDetailsForm
                eventName={eventName}
                setEventName={setEventName}
                eventDate={eventDate}
                setEventDate={setEventDate}
                eventLocation={eventLocation}
                setEventLocation={setEventLocation}
                onNext={() => {}}
            />
        </EventDashboardFrame>
    );
}
